import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Box, Grid, Heading3 } from 'edenred-ui';

import {
  AddressField,
  CityField,
  CountryField,
  InvoicingMethodRadio,
  ZipCodeField
} from '@epi-forms/controls';
import { ICompanyDataInvoicing } from '@epi-models/pages/CompanyInfo';

import { CompanyDataFormFields } from '../../helpers';

export function CompanyDataInvoicing({ editMode }: ICompanyDataInvoicing) {
  const { t } = useTranslation();

  return (
    <Box mt={5}>
      <Box mb={3}>
        <Heading3>{t('company_info.invoicing_address_heading')}</Heading3>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={8} md={4}>
          <AddressField
            name={CompanyDataFormFields.InvoicingAddress}
            disabled={!editMode}
            required={editMode}
          />
        </Grid>
        <Grid item xs={8} md={4}>
          <Grid container spacing={3}>
            <Grid item xs={6} md={5}>
              <ZipCodeField
                name={CompanyDataFormFields.InvoicingZipCode}
                disabled={!editMode}
                required={editMode}
              />
            </Grid>
            <Grid item xs={6} md={7}>
              <CityField
                name={CompanyDataFormFields.InvoicingCity}
                disabled={!editMode}
                required={editMode}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4} md={4}>
          <CountryField
            name={CompanyDataFormFields.InvoicingCountry}
            disabled={!editMode}
            required={editMode}
          />
        </Grid>
      </Grid>
      <Box mt={5} mb={3}>
        <Heading3>{t('company_info.invoicing_method_heading')}</Heading3>
        <Box>
          <Trans
            i18nKey={'company_info.invoicing_method_heading_subtext'}
            components={{
              a: (
                <a
                  title={t(
                    'company_info.invoicing_method_heading_subtext_link_title'
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={t(`company_info.invoicing_method_heading_subtext_link`)}
                />
              )
            }}
          />
        </Box>
      </Box>
      <Box>
        <InvoicingMethodRadio readOnly={!editMode} />
      </Box>
    </Box>
  );
}
